import React from "react";

import HeaderWithIcon from "../../components/common/HeaderWithIcon";
import LoadRequestTabs from "./LoadRequestTabs";
import { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { loadRequestApi } from "../../api/loadrequest";
import { TabPanel, Tabs } from "../../components/common/Tab";
import LoadRequestCard from "./LoadRequestCard";
import { Dropdown, Pagination } from "flowbite-react";

const roles = [
  { id: 0, name: "All" },
  { id: 1, name: "Admin" },
  { id: 2, name: "Incorporator" },
  { id: 3, name: "Sub Operator" },
  { id: 4, name: "General Coordinator" },
  { id: 5, name: "Coordinator" },
  { id: 6, name: "Sub Coordinator" },
  { id: 7, name: "Agent" },
  { id: 8, name: "Sub Agent" },
  { id: 9, name: "Player" },
];

export default function LoadRequest() {
  const { user, tokens } = useAuth();
  const [loadRequests, setLoadRequests] = useState([]);
  const [selectedRole, setSelectedRole] = useState(user.roleId+1);
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("ALL");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const ITEMS_PER_PAGE = 20;

  const statusTabs = [
    { title: "All", value: "ALL" },
    { title: "Pending", value: "PENDING" },
    { title: "Approved", value: "APPROVED" },
    { title: "Rejected", value: "REJECTED" },
  ];

  const fetchLoadRequests = async (status, page = currentPage) => {
    setIsLoading(true);
    try {
      const { status: responseStatus, data } = await loadRequestApi.getLoadRequest(tokens.access.token, {
        page,
        limit: ITEMS_PER_PAGE,
        roleId: selectedRole || 0,
        status: status,
      });
      if (responseStatus === 200) {
        setLoadRequests(data.rows || []);
        setTotalPages(Math.ceil(data.count / ITEMS_PER_PAGE));
      }
    } catch (error) {
      console.error("Error fetching load requests:", error);
    }
    setIsLoading(false);
  };

  const handleTabChange = (status) => {
    console.log('status', status);
    setActiveTab(status);
    fetchLoadRequests(status);
  };

  const onPageChange = (page) => {
    setCurrentPage(page);
    fetchLoadRequests(activeTab, page);
  };

  useEffect(() => {
    fetchLoadRequests(activeTab);
  }, [selectedRole]);

  const formatLoadRequestData = (request) => ({
    amount: parseFloat(request.amount).toLocaleString('en-US', { minimumFractionDigits: 2 }),
    status: request.status.toLowerCase(),
    referenceNo: request.paymentReferenceNo,
    note: request.notes,
    requestFrom: request.User.name,
    requestTo: request.sourceUser.name,
    mobileNo: request.sourceUser.mobileNumber,
    date: new Date(request.createdAt).toLocaleString(),
    approvedNotes: request.approvedNotes,
    id: request.id,
    userId: request.userId,
    proofOfPaymentUrl: request.proofOfPaymentUrl,
  });

  return (
    <div className="min-h-screen relative overflow-hidden font-poppins">
      <HeaderWithIcon title="Load Request" />

      <div className="px-4">
        <div className="mb-4">
          <Dropdown
            label={roles.find(role => role.id === selectedRole)?.name || "Select Role"}
            dismissOnClick={true}
            className="w-full"
            theme={{
              floating: {
                target: "w-full px-4 py-2.5 text-sm text-gray-900 bg-white border border-gray-200 rounded-lg focus:border-blue-500 focus:ring-blue-500",
                base: "z-10 w-full bg-white rounded-lg shadow-lg border border-gray-200",
                animation: "transition-opacity",
                content: "py-1",
                item: {
                  base: "text-sm py-2.5 px-4 text-gray-900 cursor-pointer hover:bg-gray-100",
                  icon: "mr-2 h-4 w-4"
                }
              },
              arrowIcon: "ml-2 h-4 w-4"
            }}
          >
            {roles
              .filter(role => role.id > user.roleId || role.id === 0)
              .map((role) => (
                <Dropdown.Item
                  key={role.id}
                  onClick={() => setSelectedRole(role.id)}
                >
                  {role.name}
                </Dropdown.Item>
              ))}
          </Dropdown>
        </div>

        <Tabs
          tabStyle="flex justify-between border-b space-x-2.5 text-xs border-[#E1E7EF] mt-4"
          activeClass="text-[#0E64D1] px-5 py-2 border-b-2 border-[#0E64D1] font-medium"
          inactiveClass="text-black px-5 py-2 font-normal"
          activeTab={activeTab}
          onTabChange={handleTabChange}
        >
          {statusTabs.map((tab) => (
            <TabPanel
              key={tab.value}
              title={tab.title}
              value={tab.value}
            >
              <div
                className="grid grid-cols-1 md:grid-cols-2 gap-4 my-4 overflow-y-auto hide-scrollbar"
                style={{ height: "calc(100vh - 200px)" }}
              >
                {isLoading ? (
                  <div className="text-center col-span-2">Loading...</div>
                ) : loadRequests.length === 0 ? (
                  <div className="text-center col-span-2">No requests found</div>
                ) : (
                  loadRequests.map((request) => (
                    <LoadRequestCard
                      key={request.id}
                      user={user}
                      {...formatLoadRequestData(request)}
                      onStatusUpdate={() => fetchLoadRequests(activeTab)}
                    />
                  ))
                )}
              </div>
            </TabPanel>
          ))}
        </Tabs>

        <div className="flex items-center justify-center text-center mx-4 mb-4">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
            showIcons={true}
            layout="pagination"
            theme={{
              base: "flex items-center justify-center text-center mx-4 mb-4 w-full",
              layout: {
                table: {
                  base: "text-sm text-gray-700",
                  span: "font-semibold text-gray-900"
                }
              },
              pages: {
                base: "xs:mt-0 inline-flex gap-2",
                showIcon: "inline-flex",
                previous: {
                  base: "px-3 py-1 text-sm border rounded-lg hover:bg-gray-100",
                  icon: "h-5 w-5"
                },
                next: {
                  base: "px-3 py-1 text-sm border rounded-lg hover:bg-gray-100",
                  icon: "h-5 w-5"
                },
                selector: {
                  base: "px-3 py-1 text-sm border rounded-lg",
                  active: "bg-blue-500 text-white hover:bg-blue-600",
                  disabled: "opacity-50 cursor-normal"
                }
              }
            }}
          />
        </div>
      </div>
    </div>
  );
}
